import { Button, Space, message } from 'antd'
import React from 'react'
import TableAPI from '../../components/TableAPI'
import { Text } from '../../../styles/reactnative'
import EntryTime from '../../components/PositionColumns/EntryTime'
import UserTag from '../../components/UserTag'
import TextArea from 'antd/es/input/TextArea'
import API from '../../../utils/api'
import { useToken } from '../../hooks'
import { useNotification } from '../../hooks/useNotification'
export const TicketReply = ({ data, mutate = () => {} }: any) => {
	const { data: token } = useToken()
	const [reply, setReply] = React.useState(data?.reply)
	const { refresh: notimutate } = useNotification()

	const saveProcess = process => {
		API.send('POST', '/ticket/process', token + '', {
			id: data?.id,
			process,
		}).then(() => {
			message.success('성공')
			setTimeout(() => {
				mutate()
				notimutate()
			}, 100)
		})
	}

	return (
		<Space.Compact direction="horizontal" style={{ width: '100%' }} className='ovtextarea'>
			<TextArea
				value={reply}
				onChange={e => {
					setReply(e.target.value)
				}}
			/>
			<Button
				onClick={() => {
					API.send('POST', '/ticket/reply', token + '', {
						id: data?.id,
						process: data?.process,
						reply,
					}).then(() => {
						message.success('성공')
						mutate()
					})
				}}>
				답변
			</Button>
			<Button onClick={() => saveProcess(1)} type="primary">
				검토
			</Button>
			<Button onClick={() => saveProcess(2)} type="primary" danger>
				완료
			</Button>
		</Space.Compact>
	)
}
